import { Button, Form, FormCheck, InputGroup, Modal, Table } from '@themesberg/react-bootstrap'
import { ErrorMessage, Formik } from 'formik'
import React from 'react'
import { depositSchema } from './schemas'
import useManageBonusVariant from './hooks/useManageBonusVariant'

const ManageBonusVariant = ({
  show,
  handleClose,
  user,
  isTenant = false
}) => {
  const {
    deposit
  } = useManageBonusVariant({ isTenant })
  console.log('user', user?.tags?.bonusTimes);
  return (
    <>
      <Formik
        initialValues={{
          bonusTimes: user?.tags?.bonusTimes ? user?.tags?.bonusTimes : ''
        }}
        validationSchema={depositSchema}
        onSubmit={(formValues, { resetForm }) => {
          deposit(formValues)
          handleClose()
          resetForm({ formValues: '' })
        }}
      >
        {({ values, touched, errors, handleChange, handleBlur, handleSubmit, resetForm }) => {
          console.log(values);
          return (
            <Form>
              <Modal
                show={show}
                onHide={handleClose}
                backdrop='static'
                keyboard={false}
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <h4>Bonus Variant for '{user?.firstName} {user?.lastName}'</h4>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                  <div className='form-group'>
                    <label
                      htmlFor='bonusTimes'
                      className={touched.bonusTimes && errors.bonusTimes ? 'text-danger' : ''}
                    >
                      Bonus Variant
                    </label>

                    <InputGroup
                      className={touched.bonusTimes && errors.bonusTimes
                        ? 'border border-danger'
                        : ''}
                    >

                      <Form.Control
                        name='bonusTimes'
                        type='number'
                        step='any'
                        placeholder='Enter the Bonus Variant'
                        value={values?.bonusTimes}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </InputGroup>

                    <ErrorMessage
                      component='div'
                      name='bonusTimes'
                      className='text-danger'
                    />
                  </div>
                </Modal.Body>
                <div className='mt-4 '>
                  <Modal.Footer className='d-flex justify-content-between align-items-center'>
                    <Button
                      variant='outline-warning'
                      onClick={() => {
                        resetForm({ formValues: '' })
                        handleClose(false)
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant='outline-success'
                      onClick={handleSubmit}
                      className='ml-2'
                    >
                      Submit
                    </Button>
                  </Modal.Footer>
                </div>
              </Modal>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default ManageBonusVariant
